import { type RouteRecordRaw } from "vue-router";

import { APP_TEMPLATEDOCUMENTS_ROUTES as TEMPLATES } from "@/Generated/Routes/paths";

import { buildBeforeEnterChain, onlyTherapistGuard } from "../guards";

export default [
  {
    path: TEMPLATES.root.path,
    components: {
      main: () => import("@/Components/layout/BlankLayout.vue"),
    },
    beforeEnter: buildBeforeEnterChain([onlyTherapistGuard]),
    meta: {
      sidebar: false,
    },
    children: [
      {
        ...TEMPLATES.root,
        component: () => import("@/Views/documents/templates/index.vue"),
      },
      {
        ...TEMPLATES.create.root,
        component: () => import("@/Views/documents/templates/create/index.vue"),
      },
      {
        ...TEMPLATES.edit.root,
        component: () => import("@/Views/documents/templates/create/index.vue"),
      },
      {
        ...TEMPLATES.view.root,
        component: () => import("@/Views/documents/templates/view/index.vue"),
      },
      {
        ...TEMPLATES.versions.root,
        component: () => import("@/Views/documents/templates/versions/index.vue"),
      },
    ],
  },
] as RouteRecordRaw[];
